import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'detalleCuponesVtas',
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -15) + "T00:00",
        hasta: this.currentdate() + "T23:59",
        estado: false,
      }

    };
  },
  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      "columnDefs": [
        { className: "dt-right", "targets": [12, 13] },
      ]
    });
    $('.box').boxWidget(); 
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px"); 
  },
  computed: {
    reporte: function () {
      return (
        "/loteip/detalle/cupones/venta?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },


  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/loteip/detalle/cupones/venta', this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            response.data.data.forEach(fila => {
              fila[17] = this.num_to_many(parseFloat(fila[17]).toFixed(2));
              fila[18] = this.num_to_many(parseFloat(fila[18]).toFixed(2));
              this.tbv.row.add(fila);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });

    },

  }
}



// WEBPACK FOOTER //
// ./src/components/posintegrado/detalleCuponesVtas/index.js